var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCtaSectionBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 724.1 724.1"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 119",
    d: "M0 0v724.1h724.1V470.6h-72.817v180.689H72.812V72.812h578.471v165.7L508.42 381.379l51.492 51.5 153.52-153.526 10.668-10.77V0z",
    fill: "currentColor"
  })));
}

export default __webpack_public_path__ + "ec7938714f37ea5c75fd9c28f9f387f1.svg";
export { SvgCtaSectionBg as ReactComponent };